import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showDescription?: boolean;
}

export default function ComicCard({ comic, showDescription = false }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 喵趣漫画免费在线阅读`}
          title={`${comic.title} - 喵趣漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex gap-1.5">
          <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
            {comic.category}
          </span>
          {comic.status === '已完结' && (
            <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-secondary-500 text-background-50 whitespace-nowrap">
              已完结
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {comic.rating}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">
          {comic.author}
        </p>
        {showDescription && (
          <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
            {comic.description}
          </p>
        )}
        <div className="mt-2 flex items-center justify-between text-[10px] text-foreground-400">
          <span>更新至 {comic.chapters.length} 话</span>
          <span>{comic.updatedAt}</span>
        </div>
      </div>
    </Link>
  );
}